module.exports = __webpack_public_path__ + "./fonts/ringing_bell.261399267f0c5ff6be7b194c02d0a662.mp3";